import { TableData, TableDataField } from './types';

export default class TableConfig implements TableData {
  items: object[];
  fields: TableDataField[];
  sortBy: string;

  constructor() {
    this.items = [];
    this.fields = [];
    this.sortBy = '';
  }
}
